export default __webpack_public_path__ + "static/media/1725.ba77f5b4.png";